const share = {
  //存缓存
  set(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  //取缓存中的值
  get(key) {
    return JSON.parse(sessionStorage.getItem(key));
  },
  //获取缓存中某个列表中指定键值的项的value
  getValue(key, selectKey) {
    if (selectKey !== "") {
      return this.get(key).filter(item => {
        return item.key == selectKey;
      })[0].value;
    } else {
      return "";
    }
  }
  //是否
  // whether: [
  //     {value: "是", key: "1"},
  //     {value: "否", key: "0"},
  // ],
};
export default share;
